module.exports = __webpack_public_path__ + "img/icon_ph.a623c62d.svg";